import Axios from "axios";
import {
    SET_ASSET_STATUS_TYPES_LIST,
    UNSET_ASSET_STATUS_TYPES_LIST,
} from "@/store/mutation-types";

import { saveUpdateAssetStatusType, getAssetStatusTypesList } from "@/store/api";

const state = {
    getAssetStatusTypesList: [],
};

const getters = {
    getAssetStatusTypesList(state) {
        return state.getAssetStatusTypesList;
    }
};

const mutations = {
    [SET_ASSET_STATUS_TYPES_LIST](state, data) {
        state.getAssetStatusTypesList = data;
    },
    [UNSET_ASSET_STATUS_TYPES_LIST](state) {
        state.getAssetStatusTypesList = [];
    }
};

const actions = {
    saveUpdateAssetStatusType({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateAssetStatusType, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getAssetStatusTypesList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetStatusTypesList, data)
                .then(function (response) {
                    commit('SET_ASSET_STATUS_TYPES_LIST', response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ASSET_STATUS_TYPES_LIST');
                    reject(error);
                })
                .then((always) => {
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
